<template>
  <section class="settings-card">
    <h2 class="card-title">项目基本信息</h2>
    <el-form :model="form" :rules="rules" ref="form" label-position="top" class="info-form">
      <div class="form-row">
        <el-form-item label="项目代号" prop="code" class="form-half">
          <el-input v-model="form.code" disabled></el-input>
        </el-form-item>
        <el-form-item label="项目名称" prop="name" class="form-half">
          <el-input v-model="form.name" placeholder="请输入项目名称"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="项目备注" prop="remark">
        <el-input type="textarea" v-model="form.remark" placeholder="请输入项目备注" :rows="4"></el-input>
      </el-form-item>
      <div class="form-row">
        <el-form-item label="项目状态" prop="status" class="form-half">
          <el-select v-model="form.status" style="width: 100%;">
            <el-option label="进行中 (Active)" :value="1"></el-option>
            <el-option label="已完成 (Completed)" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围" class="form-half">
          <div class="date-range">
            <el-date-picker v-model="form.startTime" type="date" placeholder="开始时间" value-format="yyyy-MM-dd"></el-date-picker>
            <span class="date-sep">至</span>
            <el-date-picker v-model="form.endTime" type="date" placeholder="截止时间" value-format="yyyy-MM-dd"></el-date-picker>
          </div>
        </el-form-item>
      </div>
      <div class="form-actions">
        <el-button type="primary" @click="saveSettings" :loading="saving" class="save-btn">保存基本信息</el-button>
      </div>
    </el-form>
  </section>
</template>

<script>
import { getProjectDetail, updateProject } from 'index/api/project/manager'

export default {
  name: 'ProjectInfoCard',
  props: {
    projectId: { type: [String, Number], required: true }
  },
  data() {
    return {
      saving: false,
      form: { code: '', name: '', remark: '', status: 1, startTime: null, endTime: null, targetQuota: null },
      rules: { name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }] }
    }
  },
  mounted() { this.loadProject() },
  methods: {
    async loadProject() {
      try {
        const res = await getProjectDetail(this.projectId)
        const data = res?.data?.data || res?.data || res
        if (data) this.applyData(data)
      } catch (e) {
        console.error('加载项目详情失败', e)
        const data = e?.data?.data || e?.data
        if (data) this.applyData(data)
      }
    },
    applyData(data) {
      this.form = {
        code: data.code || data.Code || '',
        name: data.name || data.Name || '',
        remark: data.remark || data.description || data.Description || '',
        status: data.status || data.Status || 1,
        startTime: data.startTime || data.StartTime || data.start_time || null,
        endTime: data.endTime || data.EndTime || data.end_time || null,
        targetQuota: data.targetQuota || data.TargetQuota || data.target_quota || null
      }
    },
    async saveSettings() {
      try {
        await this.$refs.form.validate()
        this.saving = true
        await updateProject({
          id: this.projectId, name: this.form.name, description: this.form.remark,
          status: this.form.status, startTime: this.form.startTime,
          endTime: this.form.endTime, targetQuota: this.form.targetQuota
        })
        this.$message.success('保存成功')
      } catch (e) {
        if (e !== false) this.$message.error(e?.data?.message || e?.message || '保存失败')
      } finally { this.saving = false }
    }
  }
}
</script>
